import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.264 9.868a.9.9 0 0 1 1.272 0L12 14.332l4.464-4.464a.9.9 0 0 1 1.272 1.273l-5.1 5.1a.9.9 0 0 1-1.272 0l-5.1-5.1a.9.9 0 0 1 0-1.273"
    }, null, -1)
  ])))
}
export default { render: render }